import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Http } from '@angular/http';
import { ModalService } from '../../../_common/modal/modal-service';

@Component({
  selector: 'app-message-form',
  templateUrl: './message-form.component.html',
  styleUrls: ['./message-form.component.scss'],
})
export class MessageFormComponent implements OnInit {
  @ViewChild('thankyou') thanks: ElementRef;

  name: string;
  email: string;
  message: string;
  http: Http;

  constructor(http: Http, private _ModalService: ModalService) {
    this.http = http;
  }

  ngOnInit() {}

  send() {
    this.http
      .post('https://katrukhin.com/assets/js/e-mail.php', {
        name: this.name,
        email: this.email,
        message: this.message,
      })
      .subscribe(() => {
        this._ModalService.createModal(true);
        this._ModalService.setContent(this.thanks);
      });
  }

  close() {
    this._ModalService.createModal(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/message-form/message-form.component.ts